// extracted by mini-css-extract-plugin
module.exports = {"information":"_3QBpp","delimiter":"_1OMEU"};